import { useNavigate } from 'react-router-dom'
import invoiceData from './invoiceData'
import GenericTable from '../../cars/components/V3/_shared/GenericTable/GenericTable'
import { TableMobileCardContent } from '../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'
import { formatDate, formatCurrency } from '../../../utils/tableFuncs'
import type { Row } from '@tanstack/react-table'
import type { InvoiceData } from '../../../types'

type InvoiceListProps = {
  data: InvoiceData[]
  isLoading?: boolean
}

function InvoiceList({ data, isLoading }: InvoiceListProps) {
  const columns = invoiceData()
  const navigate = useNavigate()

  return (
    <GenericTable
      className="max-h-[50vh]"
      isLoading={isLoading}
      data={data}
      columns={columns}
      onRowClick={(e) => {
        if (e.original.consolidateInvoiceNumber) {
          navigate(`/reports/invoice/${e.original.consolidateInvoiceNumber}`)
        }
      }}
      mobileCardContent={(row) => {
        return <MobileCardContent row={row} />
      }}
    />
  )
}

export default InvoiceList

function MobileCardContent({ row }: { row: Row<InvoiceData> }) {
  const { invoiceNumber, invoiceDate, dueDate, totalAmount, remainingAmount } = row.original
  const data = [
    {
      label: 'Fakturanr',
      value: invoiceNumber || '',
    },
    {
      label: 'Fakturadato',
      value: formatDate(invoiceDate) || '',
    },
    {
      label: 'Forfallsdato',
      value: formatDate(dueDate) || '',
    },
    {
      label: 'Totalbeløp',
      value: formatCurrency(totalAmount) || '',
    },
    {
      label: 'Restbeløp',
      value: formatCurrency(remainingAmount) || '',
    },
  ]
  const header = `Faktura - ${invoiceNumber}`
  return <TableMobileCardContent header={header} data={data} />
}
